import { Reducer } from 'redux';
import { types } from './SecurityActions';
import {
    IWorkspaceState,
    IWorkspaceAction,
} from '../../../common/model/WorkspaceModels';
import utils from '../../../utils/utils';

export const securityReducer: Reducer<IWorkspaceState, IWorkspaceAction> = (
    state: IWorkspaceState = {
        workspaceList: { pageSize: 0, total: 0, items: [] },
    },
    action: IWorkspaceAction
) => {
    switch (action.type) {
        case types.GET_WORKSPACE_ACCESSES_LIST_REQUEST: {
            return {
                ...state,
                workspaceAccessListLoading: true,
            };
        }
        case types.GET_WORKSPACE_ACCESSES_LIST_SUCCESS: {
            return {
                ...state,
                workspaceAccessListLoading: false,
                workspaceAccessList: action.payload?.data,
            };
        }
        case types.GET_WORKSPACE_ACCESSES_LIST_FAILURE: {
            return {
                ...state,
                workspaceAccessListLoading: false,
                workspaceAccessListError: action.error,
            };
        }
        case types.GET_WORKSPACE_SECURITY_LIST_REQUEST: {
            return {
                ...state,
                workspaceStatusListLoading: true,
            };
        }
        case types.GET_WORKSPACE_SECURITY_LIST_SUCCESS: {
            return {
                ...state,
                workspaceStatusListLoading: false,
                workspaceStatusList: action.payload?.data,
            };
        }
        case types.GET_WORKSPACE_SECURITY_LIST_FAILURE: {
            return {
                ...state,
                workspaceStatusListLoading: false,
                workspaceSecurityByStatusListError: action.error,
            };
        }
        case types.GET_WORKSPACE_PENDING_LIST_REQUEST: {
            return {
                ...state,
                workspacePendingListLoading: true,
            };
        }
        case types.GET_WORKSPACE_PENDING_LIST_SUCCESS: {
            return {
                ...state,
                workspacePendingListLoading: false,
                workspacePendingList: action.payload?.data,
            };
        }
        case types.GET_PENDING_INVITE_REQUEST: {
            return {
                ...state,
                pendingInvitesLoading: true,
            };
        }
        case types.GET_PENDING_INVITE_SUCCESS: {
            return {
                ...state,
                pendingInvitesLoading: false,
                pendingInvitesList: action.payload?.data,
            };
        }
        case types.GET_PENDING_INVITE_FAILURE: {
            return {
                ...state,
                pendingInvitesLoading: false,
                pendingInvitesListError: action.error,
            };
        }
        case types.INVITE_USER_REQUEST: {
            return {
                ...state,
                userInvitePending: false,
            };
        }
        case types.INVITE_USER_SUCCESS: {
            return {
                ...state,
                userInvitePending: false,
                workspacePendingList: {
                    ...state.workspacePendingList,
                    total: state.workspacePendingList.total + 1,
                    items: utils.upsertItem(
                        state.workspacePendingList.items,
                        action.payload.data
                    ),
                },
            };
        }
        case types.INVITE_USER_FAILURE: {
            return {
                ...state,
                userInvitePending: false,
                userInviteError: action.error,
            };
        }
        case types.POST_INVITATION_RESPONSE: {
            return {
                ...state,
                userInviteResponsePending: false,
            };
        }
        case types.POST_INVITATION_REJECT_SUCCESS: {
            return {
                ...state,
                userInviteResponsePending: false,
                pendingInvitesList: {
                    ...state.pendingInvitesList,
                    total: state.pendingInvitesList.total - 1,
                    items: utils.removeObjectFromList(
                        state.pendingInvitesList.items,
                        action.payload.inviteId
                    ),
                },
            };
        }
        case types.POST_INVITATION_FAILURE: {
            return {
                ...state,
                userInviteResponsePending: false,
                userInviteResponseError: action.error,
            };
        }
        case types.REVOKE_ACCESS_SUCCESS: {
            return {
                ...state,
                workspaceAccessList: {
                    ...state.workspaceAccessList,
                    total: state.workspaceAccessList.total - 1,
                    items: utils.removeUserFromList(
                        state.workspaceAccessList.items,
                        action.payload.userId
                    ),
                },
            };
        }
        case types.CANCEL_INVITE_SUCCESS: {
            return {
                ...state,
                workspacePendingList: {
                    ...state.workspacePendingList,
                    total: state.workspacePendingList.total - 1,
                    items: utils.removeObjectFromList(
                        state.workspacePendingList.items,
                        action.payload.inviteId
                    ),
                },
            };
        }
        case types.CHANGE_ROLE_SUCCESS: {
            return {
                ...state,
                workspaceAccessList: {
                    ...state.workspaceAccessList,
                    items: utils.upsertItem(
                        state.workspaceAccessList.items,
                        action.payload.data
                    ),
                },
            };
        }
        default:
            return state;
    }
};
